import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { DashboardLayout } from "@/components/DashboardLayout";
import { StatCard } from "@/components/Bits";
import { Gift, Copy, Check } from "lucide-react";
import { toast } from "sonner";

export default function AppReferrals() {
  const [data, setData] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => { api.get("/referrals").then((r) => setData(r.data)).catch(() => {}); }, []);

  const link = data ? `${window.location.origin}${data.link}` : "";
  const copy = () => { navigator.clipboard.writeText(link); setCopied(true); toast.success("Referral link copied"); setTimeout(() => setCopied(false), 1500); };

  return (
    <DashboardLayout title="Referrals">
      {data && (
        <>
          <div className="rounded-3xl border border-border bg-gradient-to-br from-primary/10 to-accent/10 p-6">
            <div className="flex items-center gap-2"><Gift className="h-5 w-5 text-accent" /><h3 className="font-display text-lg font-semibold">Invite friends, earn Pro</h3></div>
            <p className="mt-1 text-sm text-muted-foreground">{data.reward}</p>
            <div className="mt-4 flex flex-wrap items-center gap-2">
              <input readOnly value={link} data-testid="referral-link" className="min-w-0 flex-1 rounded-xl border border-border bg-card px-3.5 py-2.5 font-mono text-sm" />
              <button onClick={copy} data-testid="referral-copy" className="flex items-center gap-1.5 rounded-xl bg-primary px-4 py-2.5 text-sm font-semibold text-primary-foreground">
                {copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />} Copy
              </button>
            </div>
            <div className="mt-4">
              <div className="flex items-center justify-between text-xs text-muted-foreground"><span>Progress to reward</span><span>{data.progress}/3 verified</span></div>
              <div className="mt-1.5 h-2 w-full overflow-hidden rounded-full bg-secondary"><div className="h-full rounded-full bg-gradient-to-r from-primary to-accent" style={{ width: `${(data.progress / 3) * 100}%` }} /></div>
              {data.reward_unlocked && <p className="mt-2 text-sm font-semibold text-bullish">Reward unlocked! 🎉</p>}
            </div>
          </div>

          <div className="mt-6 grid grid-cols-2 gap-3 md:grid-cols-4">
            <StatCard label="Clicks" value={data.clicks} testid="ref-clicks" />
            <StatCard label="Registrations" value={data.registrations} testid="ref-signups" />
            <StatCard label="Verified" value={data.verified_users} accent="text-bullish" />
            <StatCard label="Paid" value={data.paid_users} accent="text-primary" />
          </div>
          <p className="mt-4 text-xs text-muted-foreground">Anti-abuse protection ensures only verified, unique users count toward rewards.</p>
        </>
      )}
    </DashboardLayout>
  );
}
